<div class="d-flex gap-3 mt-3">
  <div class="container-box shadow-none flex-fill p-3 d-flex flex-column">
    <div class="d-flex gap-3 align-items-end" style="margin-top: -2.5rem" *ngIf="!isLoading">
      <app-avatar [text]="userName" [border]="8" borderColor="white" size="86"></app-avatar>
      <div>
        <h6 class="mb-0" i18n>Connected Airbnb Account</h6>
        <div class="d-flex gap-2 align-items-center" *ngIf="airbnbAccount">
          <div>{{ userName }} (#{{ airbnbAccount.propertyId }})</div>
          <span class="bg-active2 badge-pill text-sm px-3 py-1">
            <b>{{ airbnbAccount.rooms?.length || 0 }}</b> <ng-container i18n>Active Listings</ng-container>
          </span>
        </div>
      </div>
    </div>
    <div style="margin: 1rem -1rem 0">
      <ng-container *ngIf="isLoading; else listings">
        <app-loading-section></app-loading-section>
      </ng-container>
      <!-- <ng-template [ngTemplateOutlet]="listings"></ng-template> -->
    </div>
    <div class="flex-fill"></div>
    <div
      *ngIf="autoImportText"
      class="alert d-flex align-items-center gap-2"
      [class.alert-info]="isAutoImportRunning || importPollTimedOut"
      [class.alert-success]="isAutoImportDone"
      [class.alert-danger]="isAutoImportFailed"
    >
      <i class="far fa-spin fa-spinner" *ngIf="isAutoImportRunning"></i>
      <i class="fas fa-check-circle" *ngIf="isAutoImportDone"></i>
      <i class="fas fa-exclamation-triangle" *ngIf="isAutoImportFailed"></i>
      <div class="flex-fill">{{ autoImportText }}</div>
      <button
        *ngIf="isAutoImportFailed"
        class="btn btn-sm btn-secondary-warning"
        [disabled]="isRetryingImport"
        (click)="onRetryImport()"
      >
        <i class="far fa-spin fa-spinner" *ngIf="isRetryingImport"></i>
        <ng-container i18n>Retry Import</ng-container>
      </button>
    </div>
    <div *ngIf="hasImported && !isImporting" class="alert alert-success d-flex align-items-center gap-2">
      <i class="fas fa-check-circle"></i>
      <ng-container i18n>Listings imported. Click Done to finish.</ng-container>
    </div>
    <div class="d-flex gap-3 align-items-center">
      <ng-container *ngIf="airbnbAccount">
        <button class="btn btn-secondary-danger" (click)="onDisconnect()">
          <ng-container i18n>Disconnect</ng-container> <i class="cs-icon cs-icon-unlink"></i>
        </button>
        <div class="flex-fill"></div>
        <button
          class="btn btn-secondary-warning"
          matTooltip="Import selected listings into AdvanceCM"
          matTooltipPosition="above"
          i18n-matTooltip
          [disabled]="selection.isEmpty() || isImporting"
          (click)="onImport()"
        >
          <i class="far fa-spin fa-spinner" *ngIf="isImporting"></i>
          <i class="cs-icon cs-icon-download2" *ngIf="!isImporting"></i>
          <ng-container i18n>Import Listing</ng-container>
        </button>
      </ng-container>
      <button class="btn btn-secondary-info" (click)="done.emit()">
        <i class="cs-icon cs-icon-tasks"></i> <ng-container i18n>Done</ng-container>
      </button>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4 py-5">
    <img src="/assets/images/channel-wizards/airbnb/airbnb-complete1.webp" alt="" class="w-75" />
  </div>
</div>

<ng-template #listings>
  <div i18n class="text-italic text-light px-3 py-2 border-top border-bottom">
    These listings are available for import into AdvanceCM.
  </div>
  <mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef i18n> Name</mat-header-cell>
      <mat-cell *matCellDef="let element" class="d-flex align-items-center gap-2">
        <app-avatar-name
          [name]="element.name || element.roomName || element.propertyName"
          [imageSize]="25"
        ></app-avatar-name>
        <ng-container *ngIf="isAirbnbSyncPaused(element)">
          <span
            *ngIf="element.airbnb_deleted || element.sync_paused_reason === 'deleted_on_airbnb'; else inactiveStatus"
            class="badge badge-danger badge-pill"
            matTooltip="This listing was deleted on Airbnb. AdvanceCM has paused Airbnb API sync for it."
            matTooltipPosition="above"
            i18n
            i18n-matTooltip
          >
            Deleted
          </span>
          <ng-template #inactiveStatus>
            <span
              class="badge badge-warning badge-pill"
              matTooltip="This listing is not currently active on Airbnb. AdvanceCM has paused Airbnb API sync for it."
              matTooltipPosition="above"
              i18n
              i18n-matTooltip
            >
              Inactive
            </span>
          </ng-template>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="onMasterChange($event.checked)" [checked]="isMasterChecked()"> </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-checkbox
          (change)="onSelect(element, $event.checked)"
          [checked]="selection.isSelected(element)"
          [disabled]="isAirbnbSyncPaused(element)"
          *ngIf="!isImported(element) && !isImporting"
        >
        </mat-checkbox>
        <i class="far fa-spin fa-spinner" *ngIf="isImporting && selection.isSelected(element)"></i>
        <i
          class="cs-icon cs-icon-check text-success"
          matTooltip="Listing is imported"
          i18n-matTooltip
          *ngIf="isImported(element)"
        ></i>
      </mat-cell>
    </ng-container>

    <!-- <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row> -->
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <div *ngIf="!dataSource.data?.length" class="p-5 text-light text-center" i18n>There is no listing</div>
  <mat-paginator2
    #paginator
    *ngIf="dataSource.data?.length"
    [length]="dataSource?.data?.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20, 50]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</ng-template>
